import React from 'react';
import proptypes from 'prop-types';
const { bool } = proptypes;
import { LoadingIndicator } from '../loading-indicator/loading-indicator';
import styles from './spinner.module.scss';

export default function Spinner({
  active,
}) {
  return active ? (
    <div data-testid="spinner" className={styles.spinnerWrap}>
      <LoadingIndicator />
    </div>
  ) : null;
}

Spinner.propTypes = {
  active: bool,
};

Spinner.defaultProps = {
  active: false
};